import { useState, useEffect } from "react";
import { ChatIt, Contact, Header } from "@tree-company/chat-it";
import "@tree-company/chat-it/styles";
import { CollectClient } from "@tree-company/collect-js-client";
import { Footer } from "./footer";
import translate from "../locales";
import { getMunicipalityConfig } from "../config";

let responseCollectorURL = import.meta.env.VITE_COLLECT_URL;
if (import.meta.env.DEV && responseCollectorURL === undefined) {
  responseCollectorURL = "http://localhost:3000";
}

const client = new CollectClient(
  {
    url: responseCollectorURL,
    projectKey: import.meta.env.VITE_COLLECT_KEY,
  },
  { offlineAnswers: ["naam"] },
);
const response = client.initTreesponse({ language: "nl" });

const translations = {};

export default function View() {
  const gemeente = import.meta.env.VITE_GEMEENTE || "mol";
  const config = getMunicipalityConfig(gemeente);
  const [curIndex, setCurIndex] = useState(0);
  const [script, setScript] = useState(null);

  useEffect(() => {
    document.title = config.pageTitle;
    import(`../stories/${config.scriptFilename}.yarn?raw`).then((m) =>
      setScript(m.default),
    );
  }, []);

  function handleNewStep(newStep) {
    if (response.page?.name !== newStep.title) {
      response.page = { name: newStep.title, index: curIndex };
      setCurIndex(curIndex + 1);
      response.save();
    }
  }

  function handleInput(field, value) {
    response.setAnswer(field, value);
    response.save();
  }

  async function handleChatEnd() {
    response.setCompleted();
    await response.save();
  }

  if (!script) return null;

  return (
    <>
      <main className={gemeente}>
        <ChatIt
          onChatEnd={handleChatEnd}
          onInput={handleInput}
          onStepChange={handleNewStep}
          script={script}
          Contact={
            <Contact
              characterName={config.characterName}
              imageURL={config.avatarFile}
              imageAlt={translate("avatar_alt")}
            />
          }
          Header={<Header />}
          assets={config.assets}
          translations={translations}
        />
        {config.footerAvatar && config.avatarFile && (
          <div className="page__fake-footer">
            <img className="footer__avatar" alt="" src={config.avatarFile} />
          </div>
        )}
      </main>
      <Footer logoGemeente={config.logoFile} gemeente={gemeente} />
    </>
  );
}
